import axios from 'axios';
import { objectToQuery } from '@mx/util/object-to-query';
import { toast, modal } from '@mx/vix';
import { bridge } from './bridge';
import { env } from './env';
import { Runtime } from './enum-type';

export enum ErrorLevel {
  TOAST = 1,
  MODAL_EXIT,
  MODAL,
  EXIT,
  INLINE,
}

interface AjaxSettings {
  showToast: boolean;
}

interface CommonQueryParams {
  member_id?: string;
}

class CustomError extends Error {
  constructor(message: string, public level: ErrorLevel, public code: number) {
    super(message);
  }
}

// header 信息设置 pay-request-Id，方便前后端联合查询，串联一次用户请求
// M-traceId 及 pay-request-Id 都上报至 Raptor 及灵犀
axios.interceptors.response.use((response) => {
  env.payRequestId =
    env.payRequestId || response.headers['pay-request-id'] || '';
  env.traceId = response.headers['m-traceid'] || '';
  if (env.payRequestId) {
    axios.defaults.headers.post['pay-request-id'] = env.payRequestId;
  }
  return response;
});

// test/dev 接口超时时间为 30s,st/prod 接口超时时间为 20s
const axiosTimeout =
  env.runtime === Runtime.Prod || env.runtime === Runtime.Staging
    ? 20000
    : 30000;

export function post(
  url: string,
  data?: any,
  settings: AjaxSettings = { showToast: true }
) {
  if (settings.showToast) {
    toast.show();
  }
  const params: CommonQueryParams = {};
  if (env.memberId) {
    params.member_id = env.memberId;
  }
  return axios
    .post(url, data, {
      transformRequest: (rawData) => {
        return objectToQuery({ ...env.commonParams, ...rawData });
      },
      params,
      timeout: axiosTimeout,
    })
    .then((res) => {
      if (settings.showToast) {
        toast.hide();
      }
      const body = res.data; // 响应体
      if ('error' in body) {
        throw body.error;
      }
      return body.data; // 响应体中数据
    })
    .catch((error) => {
      if (settings.showToast) {
        toast.hide();
      }
      errorHandler(error);
      throw error;
    });
}

function errorHandler(error: CustomError): void {
  // 通用错误码处理
  switch (error.code) {
    case 500010: // "未登录，请重新登录"
    case 500011: // "登陆信息异常，请重新登陆后再试"
    case 401: // "登录失败"
      bridge.login(env.runtime);
      break;
    // return;
    default:
      break;
  }

  switch (error.level) {
    case ErrorLevel.TOAST:
      toast.show('text', error.message);
      break;
    case ErrorLevel.MODAL_EXIT:
    case ErrorLevel.EXIT:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
            bridge.closeWebview();
          },
        },
      });
      break;
    case ErrorLevel.MODAL:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
          },
        },
      });
      break;
    default:
      break;
  }
}
